import { z } from 'zod';
export const LoginRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email('Ingresá un email válido'),
    password: z
        .string()
        .min(8, 'Mínimo 8 caracteres')
        .max(128, 'Máximo 128 caracteres'),
    recordarme: z.boolean().optional().default(false),
});
export const SesionUsuarioSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    nombreCompleto: z.string(),
    roles: z.array(z.string()),
    sucursalPreferidaId: z.string().uuid().optional(),
    esPromotor: z.boolean().default(false),
    esPromotorExterno: z.boolean().default(false),
    promotorId: z.string().uuid().nullable().optional(),
    promotorNombre: z.string().nullable().optional(),
});
export const TokensSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
});
export const LoginResponseSchema = TokensSchema.extend({
    usuario: SesionUsuarioSchema,
});
export const ForgotRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email('Ingresá un email válido'),
});
export const ResetRequestSchema = z
    .object({
    token: z.string().min(10, 'Token inválido'),
    password: z.string().min(10, 'Mínimo 10 caracteres').max(128),
    confirmacion: z.string(),
})
    .refine((d) => d.password === d.confirmacion, {
    path: ['confirmacion'],
    message: 'Las contraseñas no coinciden',
});
